module.exports = __webpack_public_path__ + "../resources/img/ic_refresh.f3cf6af4.svg";